import * as Yup from "yup";
import {_t} from "../i18n/lang";


/**
 * Funkcja walidacyjna dla Yup (Formik) umożliwiająca sprawdzenie równości dwóch pól
 * Użycie (dla przykladowcyh pol 'password' i 'pass_repeat'):
 * Yup.addMethod(Yup.string, 'equalTo', yupEqualTo);
 * i w validationSchema
 *  pass_repeat: Yup.string().equalTo(Yup.ref('password'))
 */
export function yupEqualTo(ref, msg = "") {
    return Yup.mixed().test({
        name: 'equalTo',
        exclusive: false,
        message: msg || _t("FIELDS-MUST-MATCH"),
        params: {
            reference: ref.path,
        },
        test: function(value) {
            return value === this.resolve(ref);
        }
    });
}